module.exports = __webpack_public_path__ + "img/ticket_text1.e085dc27.svg";